import { LOGO_URL } from "@/components/Header";
import { scrollToId } from "@/App";
import { ArrowUp } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#090D16] border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5 mb-5">
              <img src="/logo-mark-white.png" alt="SORTD logo" className="h-10 w-10 object-contain" />
              <span className="font-display font-extrabold text-lg tracking-[0.14em] text-white">
                SORTED<span className="text-emerald-400">.</span>
              </span>
            </div>
            <p className="text-sm text-slate-400 leading-relaxed max-w-sm">
              People. Relationships. Opportunities. Growth. That's SORTD.
            </p>
            <p className="font-mono-accent text-[11px] tracking-[0.25em] text-slate-500 mt-4 uppercase">
              Business Growth &amp; Commercial Development
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs font-semibold text-slate-500 uppercase tracking-widest mb-5">Explore</h4>
            <ul className="space-y-3">
              {[
                ["Services", "services"],
                ["Who We Help", "who-we-help"],
                ["Process", "process"],
                ["Results", "results"],
                ["FAQ", "faq"],
                ["Contact", "contact"],
              ].map(([label, id]) => (
                <li key={id}>
                  <button
                    data-testid={`footer-link-${id}`}
                    onClick={() => scrollToId(id)}
                    className="text-sm text-slate-400 hover:text-emerald-400 transition-colors"
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-xs font-semibold text-slate-500 uppercase tracking-widest mb-5">Get in touch</h4>
            <a
              data-testid="footer-email-link"
              href="mailto:antonette.ram@hotmail.co.nz"
              className="text-sm text-slate-300 hover:text-emerald-400 transition-colors break-all"
            >
              antonette.ram@hotmail.co.nz
            </a>
            <p className="text-sm text-slate-500 mt-3">New Zealand | Australia</p>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-slate-800/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} SORTD. All rights reserved.</p>
          <button
            data-testid="footer-back-to-top"
            onClick={() => window.__lenis?.scrollTo(0, { duration: 1.4 })}
            className="flex items-center gap-2 text-xs text-slate-500 hover:text-emerald-400 transition-colors"
          >
            Back to top <ArrowUp className="w-3.5 h-3.5" />
          </button>
        </div>
      </div>
    </footer>
  );
}
